import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import { Paginate } from "../search-document-contract-moha.component";
import {Message} from "../../../../../../../core/class/message";
import {DocumentService} from "../../../../../../../core/services/document.service";
import {ProcessingService} from "../../../../../../../core/services/processing.service";
import {BlockUI, NgBlockUI} from "ng-block-ui";
import {WarningComponent} from "../../../../../../../shared/components/warning/warning.component";
import {ToastrService} from "ngx-toastr";
import {CommonService} from "../../../../../../../core/services/common.service";

@Component({
  selector: 'app-multi-delete-dialog-moha',
  templateUrl: './multi-delete-dialog-moha.component.html',
  styleUrls: ['./multi-delete-dialog-moha.component.scss']
})
export class ListMultiDeleteDialogComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  subtitle: string;
  subtitle1: string;
  subtitle2: string;
  dataSource: any[] = [];
  isDraftAll: any;
  listData = [];
  listDataPopup = [];
  page = 0;
  pageSize = 10;
  percent: 0;
  isProcess = false;
  isStop = false;
  timeOut: any;
  displayedColumns: string[] = [
    'STT',
    'contractName',
    'result',
    'detail'
  ];
  paginate: Paginate;
  isShowProgress = false;
  checklenghtRun = true;
  constructor(
    private message: Message,
    public dialogRef: MatDialogRef<ListMultiDeleteDialogComponent>,
    private documentService: DocumentService,
    private processingService: ProcessingService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    public commonService: CommonService,
    private dialog: MatDialog,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
    this.listDataPopup = data.dataSource;
    this.subtitle = data.subTitleDraftAll ? data.subTitleDraftAll : '';
    this.subtitle1 = data.subTitleDraftAllTotal ? data.subTitleDraftAllTotal : '';
    if ( data.isDraftAll === 4 || this.data.isProcess) {
      this.isDraftAll = true;
      this.subtitle1 = '';
    }
  }

  ngOnInit() {
    this.listDataPopup = [];
    this.listData = [];
    this.listDataPopup = this.data.selectedDraftAll;
    if (this.data.isProcess ) {
      this.onProcessing();
      this.checklenghtRun = false;
    }
    if (this.data.signContractId ) {
      this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
        if (!res || !res.data.lotDetails) {
          return;
        }
        this.dataSource = res.data.lotDetails;
        this.listDataPopup = this.dataSource;
      });
    } else {
      if (this.data.selectedDraftAll === []) {
        this.processingService.processingMultiSignStatus.next(false);
      }
      const selectedValues = Array.from(this.data.selectedDraftAll.values());
      let draftStatusValue;
      if (!this.isDraftAll) {
        draftStatusValue = selectedValues.filter((v: any) => v.status === 1);
      } else {
        draftStatusValue = selectedValues;
      }
      this.dataSource = draftStatusValue;
      this.listDataPopup = this.dataSource;
    }
    this.isProcess = this.data.isProcess ? this.data.isProcess : false;
    this.isShowProgress = this.isProcess;
    // if (this.isShowProgress) {
    //   this.subtitle1 = this.commonService.format(this.message.getMessage('messages.delete_list_docs_draft_total_runing'), this.listDataPopup.length);
    // }
    // else {
    //   this.listDataPopup.forEach((ele, i) => {
    //     if (i < 10 ) {
    //       this.listData.push(ele);
    //     }
    //     ele.order = i + 1;
    //   });
    // }
    // if (this.isProcess) {
    //   for (const item of this.listDataPopup) {
    //     item.status = 'PROCESSING';
    //   }
    // }
    this.listDataPopup.forEach((ele, i) => {
      if (i < 10 ) {
        this.listData.push(ele);
      }
      ele.order = i + 1;
    });
    this.paginate = {
      currentPage: this.page,
      pageSize: this.pageSize,
      totalRow: this.listDataPopup.length,
      totalPage: Math.ceil(this.listDataPopup.length / this.pageSize),
      totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / this.pageSize),1),
      no: this.counter(this.pageSize, this.page * this.pageSize + 1)
    };
    if (!this.data.isProcess || this.listDataPopup.length > 0) {
      this.onProcessing();
    }
    this.processingService.processingMultiSignStatus.subscribe(res => {
      this.isShowProgress = res;
    });
  }

  close() {
    this.dialogRef.close(false);
  }

  handleConfirm() {
    this.dialogRef.close(true);
  }

  onClickConfirmButton() {
    this.processingService.processingMultiSign.next(0);
    this.blockUI.reset();
    this.blockUI.start('');
    let body;
    body = this.listDataPopup.map(item => {
      return item.id;
    });
    this.processingService.processingDataRun.next(this.listDataPopup);
    this.documentService.createDeleteContractFlow({contractIds: body})
      .subscribe({
        next: rs => {
          if (rs && rs.success) {
            this.checklenghtRun = false;
            // this.subtitle1 = this.commonService.format(this.message.getMessage('messages.delete_list_docs_draft_total_runing'), body.length);
            this.subtitle = '';
            this.isProcess = true;
            this.isShowProgress = true;
            if (!this.isDraftAll) {
              this.processingService.processingCheckMan.next(5);
              localStorage.setItem('checkMan', '5' );
            } else {
              this.processingService.processingCheckMan.next(6);
              localStorage.setItem('checkMan', '6' );
            }
            this.processingService.processingMultiSignStatus.next(this.isProcess);
            this.data.signContractId = rs.data;
            this.data.onClickDeleteConfirmButton();
            this.onProcessing();
            this.blockUI.stop();
          } else {
            this.blockUI.stop();
            this.toastr.error(rs.message);
          }
        },
        error: err => {
          this.blockUI.stop();
        }
      });
  }

  onProcessing() {
    if (this.data.signContractId) {
      this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
        if (!res || !res.data.lotDetails) {
          return;
        };
        this.dataSource = res.data.lotDetails;
        this.listDataPopup = this.dataSource;
        this.onFilterData(this.page, this.pageSize);
        this.processingService.processingDataRun.next(this.listDataPopup);
      });
    }
    this.processingService.processingMultiSign.subscribe(ref => {
      const process = ref;
      if (process > 0) {
        this.percent = process;
        if (this.data.signContractId) {
          this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
            if (!res || !res.data.lotDetails) {
              return;
            }
            this.dataSource = res.data.lotDetails;
            this.listDataPopup = this.dataSource;
            this.onFilterData(this.page, this.pageSize);
            this.processingService.processingDataRun.next(this.listDataPopup);
          });
        }
        if (process === 100 && this.data.signContractId) {
          this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
            if (!res || !res.data.lotDetails) {
              return;
            }
            this.dataSource = res.data.lotDetails;
            this.listDataPopup = this.dataSource;
            this.onFilterData(this.page, this.pageSize);
            this.processingService.processingDataRun.next(this.listDataPopup);
          });
          this.isStop = true;
          this.timeOut = setTimeout(() => {
            this.isShowProgress = false;
          }, 2000);
        }
      }
    });
  }

  stop() {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_contact_stop'), this.listDataPopup.length)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.onClickStopSign();
      } else {
        dialogRef.close(false);
      }
    });
  }

  onClickStopSign() {
    // show confirm poup.
    const popup = this.dialog.open(WarningComponent, {
      width: '30%',
      data: 'messages.confirm_delete_contact_stop'
    });

    popup.afterClosed().subscribe(rs => {
      if (rs) {
        // call to server for stopping sign.
        const signContractId = this.data.signContractId;
        this.isStop = true;
        this.documentService.deleteContractFlowCancel(signContractId).subscribe(
          (res) => {
            if (res && res.success) {
              this.processingService.processingMultiSignStatus.next(false);
              this.processingService.processingMultiSignCancel.next(this.isStop);
              if (!this.isDraftAll) {
                this.processingService.processingCheckMan.next(5);
                localStorage.setItem('checkMan', '5' );
              } else {
                this.processingService.processingCheckMan.next(6);
                localStorage.setItem('checkMan', '6' );
              }
              this.isShowProgress = false;
              this.documentService.signContractFlowInfo(signContractId).subscribe(res => {
                if (!res || !res.data.lotDetails) {
                  return;
                }
                this.dataSource = res.data.lotDetails;
              });
              this.toastr.success(this.message.getMessage('messages.delete_multi_stop'));
            } else {
              this.toastr.error(this.message.getMessage('messages.delete_multi_stop_fail'));
            }
          },
          (err) => {
          },
          () => {
          }
        );
      }
    });
  }

  onFilterData(page: number = 0, pageSize: number = 10) {
    this.page = page;
    this.pageSize = pageSize;
    this.listData = [];
    const a: number = page * pageSize;
    this.listDataPopup.forEach((ele, i) => {
      if (a <= i && i < a + pageSize) {
        this.listData.push(ele);
      }
      ele.order = i + 1;
    });
    this.paginate = {
      currentPage: page,
      pageSize: pageSize,
      totalRow: this.listDataPopup.length,
      totalPage: Math.ceil(this.listDataPopup.length / pageSize),
      totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / pageSize),1),
      no: this.counter(pageSize, page * pageSize +1)
    };
  }

  counter(index: number , from: number){
    return new Array(index).fill(0).map((x, i: number) => i + from);
  }

  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('sign_contract_flow.error');
      case 'PROCESSING':
      case 'CANCEL':
        return this.message.getMessage('sign_contract_flow.process');
      case 'DONE':
        return this.message.getMessage('sign_contract_flow.success');
      default:
        return '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return {'color': 'red', 'border': '1px solid red', 'border-radius': '5px'};
      case 'PROCESSING':
      case 'CANCEL':
        return {'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px'};
      case 'DONE':
        return {'color': 'green', 'border': '1px solid green', 'border-radius': '5px'};
      default:
        return {};
    }
  }
}

